import './typographyStyles.css';
export var replaceSlashedZero = '_wlksqp0-2-0-1';